export default "/_next/static/sounds/mum-iknowyourebusy-29fe4a20a94698d213fc7bc0e219fca3.mp3";